import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/authservice';
import { Router } from '@angular/router';
@Injectable()
export class IsLoginGuard implements CanActivate, CanActivateChild {

    constructor(private auth: AuthService, private router: Router) {
    }
    private checkSiteAuth = '';
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.auth.User) {
            this.router.navigateByUrl('/login');
            return false;
        }

        return true;
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {


        if (route.data.hasOwnProperty("RequiredAccessRight")) {
            if (!this.auth.GetAccessRight(route.data.RequiredAccessRight))
                this.router.navigateByUrl('/accessdenied');
        }

        this.auth.UpdateTitle(route.data.Title || '', route.data.SubTitle || '');

        return true;
    }
}